import apiClient from '../../../common/functions/api_axios_instance.function';
import { handleApiError } from '../../../common/functions/errorHandler.function';

export const updateRouteName = async (id, updatedName) => {
  try {
    const response = await apiClient.put(`/routes/updateRouteName/${id}`, updatedName);

    return response.data;
  } catch (error) {
    handleApiError(error);
  }
};
